import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import {Button, DatePicker, Form, Input, Select} from "antd";
import React, {useEffect, useState} from "react";
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import GetProductList from "../Products/GetProductList";
import Pallet from "../../http_request/Model/pallet/Pallet";
import GetUsersFullName from "../UserManagement/GetUsersFullName";
import ResultComponent from "../../microComponents/modals/ResultComponent";
import Preview from "../../microComponents/elements/Preview";
import locale from "antd/es/date-picker/locale/fa_IR";

const {TextArea} = Input;


const PrintPallet = () => {
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [productLine, setProductLine] = useState([]);
    const [userListLoading, setUserListLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [items] = useState([]);
    const [code, setCode] = useState();
    const [openResult, setOpenResult] = useState(false);
    const [data, setData] = useState({});


    const onFinishFailed = (errorInfo) => {
        setShowModal(false)
    };


    const onFinish = (values) => {
        setShowModal(true)


    };

    const handleSubmit = () => {
        const values = form.getFieldsValue()
        Pallet.request({
            beforeSend: () => {
                setLoading(true)
                setShowModal(false)
                form.resetFields()
            }, success: (result) => {
                setCode(result)
                setOpenResult(true)
            }, final: () => {
                setLoading(false)
            }


        }).createProduce(values)
    };


    useEffect(() => {

        getFilterProductLine(setProductLine, setProductLineLoading)
        GetProductList(setProductList, setProductListLoading)


        // get userList
        GetUsersFullName(setUserList, setUserListLoading)

    }, []);


    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>صدور شناسه تولید</Title>

                </div>
            </ComponentCard> <ComponentCard>
            <ResultComponent openResult={openResult} setOpenResult={setOpenResult}
                             status="success"
                             title={`کد تایید: ${code}`}
                             extra={[

                                 <Button key="buy" onClick={() => {
                                     setOpenResult(false)
                                 }}>بستن</Button>,
                             ]}

            />
            <Form
                form={form}
                name="basic"
                layout='vertical'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">


                    <Form.Item
                        name="productLineId"
                        label="خط تولید"
                        rules={[{
                            required: true, message: 'لطفا خط تولید را وارد کنید!',
                        },]}

                    >
                        <Select showSearch
                                onChange={(e,x)=>{
                                    setData({...data,productLine : x})
                                }}
                                loading={productLineLoading}
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}
                                options={productLine}/>
                    </Form.Item>
                    <Form.Item
                        name="product"
                        label="محصول"
                        rules={[{
                            required: true, message: 'لطفا محصول را وارد کنید!',
                        },]}
                    >


                        <Select showSearch
                                onChange={(e, x) => {
                                    form.setFieldValue('numberPerPallet', x.numberPerPallet)

                                    setData({...data,product : x})


                                }}
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}
                                loading={productListLoading}
                                options={productList}/>
                    </Form.Item>
                    <Form.Item
                        name="dateOfManufacture"
                        label="تاریخ تولید"
                        rules={[{
                            required: true, message: 'لطفا تاریخ تولید را وارد کنید!',
                        },]}
                    >

                        <DatePicker
                            locale={{
                                ...locale,
                                lang: {
                                    ...locale.lang,
                                    ok: "تایید",
                                }
                            }}
                            className='w-full' popupClassName='datePickerBtn'
                                    showTime={{format: 'HH:mm'}}

                                    onChange={(e,x)=>{
                                        setData({...data,dateOfManufacture : x})

                                    }}
                                    format="YYYY-MM-DD HH:mm"
                                    placeholder={['تاریخ تولید']}

                        />
                    </Form.Item>
                    <Form.Item
                        name="seriCreatedBy"
                        label="سرپرست تولید"
                        rules={[{
                            required: true, message: 'لطفا سرپرست تولید را وارد کنید!',
                        },]}
                    >

                        <Select showSearch
                                onChange={(e,x)=>{
                                    setData({...data,seriCreatedBy : x})

                                }}


                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}
                                loading={userListLoading}
                                options={userList}/>
                    </Form.Item>


                    <Form.Item
                        name="numberPerPallet"
                        label="تعداد در پالت"
                        rules={[{
                            required: true, message: 'لطفا تعداد در پالت را وارد کنید!',
                        },]}

                    >
                        <Input    onChange={(e)=>{
                            setData({...data,numberPerPallet : e.target.value})

                        }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="requiredNumber"
                        label="تعداد چاپ"
                        rules={[{
                            required: true, message: 'لطفا تعداد چاپ را وارد کنید!',
                        },
                            {
                                message: 'حداکثر تعداد 50 عدد می باشد.',
                                validator: (_, value) => {
                                    if (value > 0 && value <= 50) {
                                        return Promise.resolve();
                                    } else {
                                        return Promise.reject('حداکثر تعداد 50 عدد می باشد.');
                                    }
                                }
                            }


                        ]}

                    >
                        <Input type='number'  onChange={(e)=>{
                            setData({...data,requiredNumber : e.target.value})

                        }}/>
                    </Form.Item>
                    <Form.Item


                        name="description"
                        label="توضیحات"

                    >
                        <TextArea row={4}  onChange={(e)=>{
                            setData({...data,description : e.target.value})

                        }}/>

                    </Form.Item>

                </div>
                <div className="flex justify-end">
                    <Preview data={data} items={items} loading={loading} handleCheckValidate={() => {
                        form.submit()
                    }}
                             handleSubmit={handleSubmit}
                             setShowModal={setShowModal} showModalStatus={showModal} getData={() => {
                        return form.getFieldsValue()
                    }}/>
                </div>


            </Form>


        </ComponentCard></div>
    );
};


export default PrintPallet;